export default [
    {
        path: '/shop',
        component: () => import('../components/pages/shop/Shop.vue') ,
        meta: {
            title: '实体店铺'
        }
    }

]